import { firstRealEnvValue } from '@/lib/security/env-placeholders';

/**
 * Public reCAPTCHA Enterprise site key (safe to expose in the client).
 * Used when Coolify/CI still has env.example placeholders baked into NEXT_PUBLIC_*.
 */
export const KLEANERS_RECAPTCHA_SITE_KEY = '6LcyZvotAAAAALsmC_jUbhuV9n83OMAtPoPlmBDP';

/**
 * Resolve the site key for script load + execute + server assessment.
 * Prefers real env values; falls back to the known public key so placeholder
 * Coolify builds do not call Google with `your_recaptcha_site_key`.
 */
export function resolveRecaptchaSiteKey(): string {
  return (
    firstRealEnvValue(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, process.env.RECAPTCHA_SITE_KEY) ??
    KLEANERS_RECAPTCHA_SITE_KEY
  );
}
